import { render, staticRenderFns } from "./LiveRate.vue?vue&type=template&id=bcc85cc4&scoped=true&"
import script from "./LiveRate.vue?vue&type=script&lang=js&"
export * from "./LiveRate.vue?vue&type=script&lang=js&"
import style0 from "./LiveRate.vue?vue&type=style&index=0&id=bcc85cc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc85cc4",
  null
  
)

export default component.exports